// extracted by mini-css-extract-plugin
module.exports = {"holiday_container":"StaticContent_holiday_container__hENF0"};